import { Box, Typography } from '@mui/material';
import React from 'react';

interface Product {
	quantity: number;
	name: string;
	unit?: string;
	price: string;
	product_id: number;
	total?: string;
}

interface ProductsListingProps {
	products: Product[];
	style?: React.CSSProperties;
}

type ListWrapperStyles = React.CSSProperties & {
	'@media (max-width: 600px)': React.CSSProperties;
};

const listWrapperStyling: ListWrapperStyles = {
	height: '72px',
	borderBottom: '1.5px solid var(--gray-color-light)',
	borderRight: '1.5px solid var(--gray-color-light)',
	'@media (max-width: 600px)': {
		height: '89px',
	},
};

function ProductsListing({
	products,
	style = {
		height: 'calc(100vh - 500px)',
		width: '100%',
		overflowY: 'scroll',
		border: '1.5px solid var(--gray-color-light)',
		borderRadius: '4px',
		padding: '0px',
	},
}: ProductsListingProps): JSX.Element {
	return (
		<Box style={style}>
			{products?.map((ele, i) => (
				<Box key={i} display="flex" sx={listWrapperStyling}>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="center"
						style={{
							height: '100%',
							width: '88px',
							backgroundColor: 'var(--chat-outgoing)',
							borderRight: '1.5px solid var(--gray-color-light)',
						}}
					>
						{ele.quantity}
					</Box>
					<Box
						display="flex"
						alignItems="center"
						justifyContent="space-between"
						style={{
							width: '85%',
							padding: '16px',
							background: ele?.background || '',
						}}
					>
						<Box>
							<Typography
								variant="body1"
								sx={{
									'@media (max-width: 600px)': {
										fontSize: '14px',
									},
								}}
							>
								{ele.name}
							</Typography>
							<Typography
								variant="body2"
								style={{
									color: 'var(--lighter-text-color)',
								}}
							>
								{ele.unit}
							</Typography>
						</Box>
					</Box>
					<Box
						display="flex"
						alignItems="flex-end"
						style={{
							padding: '16px',
						}}
					>
						<Typography variant="body2">₹{ele.price}</Typography>
					</Box>
				</Box>
			))}
		</Box>
	);
}

export default ProductsListing;
